import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white" data-id="element-220">
      <Hero data-id="element-221" />
      <ProblemSection data-id="element-222" />
      <MethodSection data-id="element-223" />
      <BenefitsSection data-id="element-224" />
      <ForWhoSection data-id="element-225" />
      <CTASection data-id="element-226" />
      <Footer data-id="element-227" />
    </main>;
}